import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "../app/layout/auth-layout/auth-layout";
import JobBoardComponent from "../app/job-board/JobBoardComponent";

const Navigator = () => {
    return (
        <Routes>
            {/* Redirect from root path to /job */}
            <Route path="/" element={<Navigate to="/job" replace />} />

            {/* Routes with AuthLayout */}
            <Route
                path="/job"
                element={
                    <AuthLayout>
                        <JobBoardComponent />
                    </AuthLayout>
                }
            />
            <Route
                path="/job/:id"
                element={
                    <AuthLayout>
                        <JobBoardComponent />
                    </AuthLayout>
                }
            />

            {/* Catch-all route */}
            <Route path="*" element={<JobBoardComponent />} />
        </Routes>
    );
};

const MainRouter = () => {
    return (
        <BrowserRouter>
            <Navigator />
        </BrowserRouter>
    );
};

export default MainRouter;